import { useSelector, useDispatch } from 'react-redux';

import app from 'app/config/app';
import FilterValues from 'core/filter/FilterValues';
import { deleteFilterParams } from 'app/features/funding-sources/fundingSourceSlice';

export default function FundingSourceFilterValues() {
  const dispatch = useDispatch();

  const { params } = useSelector((state) => state.fundingSources.index);

  const handleOnRemoveFilter = (key) => {
    dispatch(deleteFilterParams(key));
  };

  return (
    <FilterValues
      value={params}
      onRemoveFilter={handleOnRemoveFilter}
      ignoreKeys={app.ignoreFilterKeys}
    />
  );
}
